import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Key } from "@phosphor-icons/react";

// Access details typed at request/job stage — mirrors the property record's access notes and is saved back to it.
export default function AccessNotesField({ value, onChange, propertyLinked = false, testid = "access-notes" }) {
  return (
    <div data-testid={`${testid}-section`}>
      <p className="text-xs font-semibold text-muted-foreground mb-2 flex items-center gap-1.5">
        <Key size={12} weight="duotone" /> ACCESS DETAILS
      </p>
      <Label htmlFor={testid} className="sr-only">Access details</Label>
      <Textarea
        id={testid}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
        placeholder="Alarm codes, key safe location, parking, sign-in procedure, restricted hours…"
        className="mt-1"
        data-testid={testid}
      />
      <p className="text-[11px] text-muted-foreground mt-1">
        {propertyLinked
          ? "Shown to the attending engineer. Any changes here update the linked property's access details."
          : "Shown to the attending engineer and saved to this client's property record, so you only type it once."}
      </p>
    </div>
  );
}
